module.exports = __webpack_public_path__ + "6ef1aebf545a43723762ac642e5ebe9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-1050.jpg
// module id = 198
// module chunks = 0